import { render, staticRenderFns } from "./Principles.vue?vue&type=template&id=14e82b2b&scoped=true&"
import script from "./Principles.vue?vue&type=script&lang=js&"
export * from "./Principles.vue?vue&type=script&lang=js&"
import style0 from "./Principles.vue?vue&type=style&index=0&id=14e82b2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e82b2b",
  null
  
)

export default component.exports